import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router) {}

    /**
   * Prüft, ob der eingeloggte User eine erlaubte Rolle besitzt.
   * Bei fehlender Berechtigung erfolgt Redirect zum Login.
   */
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowedRoles = route.data['roles'] as Array<string>;
    const userRole = localStorage.getItem('role');

    if (allowedRoles.includes(userRole!)) {
      return true;
    }

    this.router.navigate(['login']); 
    return false;
  }
}